import {
  AbandonedCallFollowUpFilterInput,
  FollowUpStatus,
} from '@api/generated/graphql';
import { AbandonedCallsFilters } from '../hooks/useAbandonedCallsFilters';
import { UrgentFollowUpTabs } from '@pages/urgentfollowups/types';
import { oneDayInMS } from '@pages/urgentfollowups/utils/filters';

const openFollowUpStatuses = [
  FollowUpStatus.New,
  FollowUpStatus.FollowUpNeeded,
  FollowUpStatus.ContactAttempted,
];

const coldFollowUpStatuses = [...openFollowUpStatuses];

export const doneFollowUpStatuses = [
  FollowUpStatus.Dismissed,
  FollowUpStatus.Resolved,
];

export const getAbandonedCallsBadgeCountFilters =
  (): AbandonedCallFollowUpFilterInput => {
    // If we don't floor to the nearest minute, the query perpetually
    // re-triggers, presumably due to the date's exact value changing on every
    // re-render.
    const fromDate = getOpenAbandonedCallFilters().fromDate;

    fromDate?.setMilliseconds(0);
    fromDate?.setSeconds(0);

    return {
      fromDate,
      // For the badge count we want *new* open abandoned calls.
      followUpStatuses: [FollowUpStatus.New],
    };
  };

export const getStatusFilters = (tab: UrgentFollowUpTabs): FollowUpStatus[] => {
  switch (tab) {
    case UrgentFollowUpTabs.Open:
      return openFollowUpStatuses;
    case UrgentFollowUpTabs.Cold:
      return coldFollowUpStatuses;
    case UrgentFollowUpTabs.Done:
      return doneFollowUpStatuses;
  }
};

const getOpenAbandonedCallFilters = (): Partial<AbandonedCallsFilters> => {
  return {
    fromDate: new Date(new Date().getTime() - oneDayInMS),
  };
};

const getColdAbandonedCallFilters = (): Partial<AbandonedCallsFilters> => {
  return {
    toDate: new Date(new Date().getTime() - oneDayInMS),
  };
};

const getDoneAbandonedCallFilters = (): Partial<AbandonedCallsFilters> => {
  return {};
};

export const getDefaultAbandonedCallFilters = (
  tab: UrgentFollowUpTabs,
): AbandonedCallsFilters => {
  const statuses = getStatusFilters(tab);
  const filter: AbandonedCallsFilters = {
    statuses,
    includeNullCampaigns: false,
    includeNullQueues: false,
  };

  switch (tab) {
    case UrgentFollowUpTabs.Open:
      return { ...filter, ...getOpenAbandonedCallFilters() };
    case UrgentFollowUpTabs.Cold:
      return { ...filter, ...getColdAbandonedCallFilters() };
    case UrgentFollowUpTabs.Done:
      return { ...filter, ...getDoneAbandonedCallFilters() };
  }
};
